// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3H307","rootNoMargin":"styles_rootNoMargin__3qt_w"};